export interface ISystemDetails {
    systemGuid: string;
    systemType: string;
    systemId: string;
    ownershipCode: string;
    user: string;
}

export class SystemDetails implements ISystemDetails {
    systemGuid: string;
    systemType: string;
    systemId: string;
    ownershipCode: string;
    user: string;

    constructor(systemGuid: string,
        systemType: string,
        systemId: string,
        ownershipCode: string,
        user: string) {
        this.systemGuid = systemGuid;
        this.systemId = systemId;
        this.systemType = systemType;
        this.ownershipCode = ownershipCode;
        this.user = user;
    }
}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/systemDetailsRetriever/system-details.ts
 **/